import {type ColorName, useNamedColor} from '@github-ui/use-named-color'
import {clsx} from 'clsx'

import styles from './ColorDecorator.module.css'

interface ColorDecoratorProps {
  color: ColorName
  className?: string
}

export const ColorDecorator = ({color, className}: ColorDecoratorProps) => {
  const {bg, accent} = useNamedColor(color)
  return (
    <div
      className={clsx(styles.ColorDecoratorMain, className)}
      style={{
        backgroundColor: bg,
        borderColor: accent,
      }}
    />
  )
}

try{ ColorDecorator.displayName ||= 'ColorDecorator' } catch {}